import { render } from "./ZonesPage.vue?vue&type=template&id=34b8a38e&ts=true"
import script from "./ZonesPage.ts?vue&type=script&lang=ts"
export * from "./ZonesPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__